import React from "react"
import Form from 'react-bootstrap/Form'

const InputDate = ({ fieldName, value, onChange, disabled, required, size }) => {
    const handleChange = (e) => {
        onChange(e)
    }

    return (
        <Form.Control
            type="date"
            name={fieldName}
            value={value}
            onChange={handleChange}
            disabled={!!disabled}
            required={!!required}
            style={{ textAlign: "left" }} 
            size={size || ''}
        />
    )
}

export default InputDate
